module.exports = __webpack_public_path__ + "static/bucket-07eaa34401b5ca7499c436982b71c05e.gif";